import React from 'react';
import { CardHeader, CardTitle } from '../ui/card';

/**
 * 리포트 헤더 컴포넌트
 * @param {Object} props
 * @param {Object} props.report - 리포트 데이터
 * @param {boolean} props.isExpanded - 확장 여부
 */
export const ReportHeader = ({ report, isExpanded }) => {
    // Personal News 리포트 전용 헤더
    if (report.agent_name === 'Personal News' && report?.report_content) {
        const articleCount = report.report_content.article_count ||
            (report.report_content.articles ? report.report_content.articles.length : 0);
        const userTags = report.report_content.user_tags || [];

        return (
            <CardHeader>
                <div className="flex justify-between items-center">
                    <CardTitle className="flex items-center gap-2">
                        📰 {report?.report_content['title'] || '개인맞춤 뉴스 추천'}
                        {userTags.length > 0 && (
                            <span className="text-sm font-normal text-blue-600">
                                ({userTags.join(', ')})
                            </span>
                        )}
                    </CardTitle>
                    <span className="text-xl">
                        {isExpanded ? '▼' : '▶'}
                    </span>
                </div>
                <div className="text-sm text-gray-500">
                    {report?.display_name ?? report.agent_name} (v{report.agent_version})
                </div>
                <div className="text-sm text-gray-500">
                    {new Date(report.report_date).toLocaleDateString('ko-KR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })}
                    {articleCount > 0 && (
                        <span className="ml-2">
                            ({articleCount}개 뉴스)
                        </span>
                    )}
                </div>
            </CardHeader>
        );
    }

    // 일반 리포트 헤더 (title이 있는 경우)
    if (report?.report_content && 'title' in report.report_content) {
        return (
            <CardHeader>
                <div className="flex justify-between items-center">
                    <CardTitle>
                        {report?.report_content['title']}
                    </CardTitle>
                    <span className="text-xl">
                        {isExpanded ? '▼' : '▶'}
                    </span>
                </div>
                <div className="text-sm text-gray-500">
                    {report?.display_name ?? report.agent_name} (v{report.agent_version})
                </div>
                <div className="text-sm text-gray-500">
                    {new Date(report.report_date).toLocaleDateString('ko-KR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })}
                    <span className="ml-2">
                        {report?.report_content?.papers?.length ? (`(${report?.report_content?.papers?.length}편)`) : ''}
                    </span>
                </div>
            </CardHeader>
        );
    }

    // 일반 리포트 헤더 (title이 없는 경우)
    return (
        <CardHeader>
            <div className="flex justify-between items-center">
                <CardTitle>
                    {report?.display_name ?? report.agent_name} (v{report.agent_version})
                </CardTitle>
                <span className="text-xl">
                    {isExpanded ? '▼' : '▶'}
                </span>
            </div>
            <div className="text-sm text-gray-500">
                {new Date(report.report_date).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })}
                <span className="ml-2">
                    {report?.report_content?.papers?.length ? (`(${report?.report_content?.papers?.length}편)`) : ''}
                </span>
            </div>
        </CardHeader>
    );
};

export default ReportHeader;
